import { NgFor, NgIf } from '@angular/common';
import { Component, inject} from '@angular/core';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { StoredPhoto } from '@shared/types';
import { DatabaseService } from '../../services/database.service';
import { StorageService } from 'src/app/services/storage.service';


@Component({
  selector: 'app-manage-photos',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    NgIf,
    NgFor,
    MatProgressSpinnerModule,
    MatIcon
  ],
  templateUrl: './manage-photos.component.html',
  styleUrl: './manage-photos.component.scss'
})
export class ManagePhotosComponent {

  ready = false;

  photos: StoredPhoto[] = [];


  constructor(
    private db: DatabaseService,
    private dialog: MatDialog
  ) {
    this.loadPhotoList();
  }

  private async loadPhotoList() {
    this.photos = await this.db.getPhotos();
    this.photos.forEach( photo => { if (photo.on === undefined) photo.on = true; });
    this.ready = true;
  };

  editRecord(index: number) {
    const data = {
      mode: 'edit',
      index: index, 
      photos: this.photos
    };
    const dialogRef = this.dialog.open(ManagePhotosDialog, {data});

    dialogRef.afterClosed().subscribe(result => {
      console.log('result', result);
      if ( result )
        this.photos = result;
    });
  }


  removeRecord(index: number) {
    const title = this.photos[index].title;
    const result = confirm(`Do you really want to remove photo \'${title}\'?`);
    if ( result ) {
      this.photos.splice(index, 1);
      this.db.setPhotos(this.photos);
    }
  }

  public reorderRecord(index: number, direction: 'up' | 'down') {
    const newIndex = direction === 'up' ? index - 1 : index + 1;
    const length = this.photos.length
    if (newIndex >= 0 && newIndex < length) {
      const newIndex = direction === 'up' ? index - 1 : index + 1;
      const movedPhoto = this.photos.splice(index, 1)[0];
      this.photos.splice(newIndex, 0, movedPhoto);
    }
    this.db.setPhotos(this.photos);
  }


  addRecord(index: number) {
    const data = {
      mode: 'add',
      index: index, 
      photos: this.photos
    };
    const dialogRef = this.dialog.open(ManagePhotosDialog, {data});
    dialogRef.afterClosed().subscribe(
      (photos: StoredPhoto[] | null) => {
      if ( photos ) {
        this.photos = photos;
      }
    });
  }

}





// MANAGE-PHOTOS DIALOG
@Component({
  selector: 'manage-photos-dialog',
  templateUrl: 'manage-photos-dialog.html',
  styleUrl: './manage-photos.component.scss',
  standalone: true,
  imports: [
    NgIf,
    ReactiveFormsModule,
    MatProgressSpinnerModule
  ],
})
export class ManagePhotosDialog {

  readonly dialogRef = inject(MatDialogRef);
  readonly data = inject<{
    mode: 'add' | 'edit',
    index: number,
    photos: StoredPhoto[]
  }>(MAT_DIALOG_DATA);

  editForm: FormGroup;
  uploading = false;
  loadingPhoto = false;

  imageSrc: string = '';
  file: File | null = null; 

  constructor(
    private db: DatabaseService,
    private storage: StorageService,
    public formBuilder: FormBuilder
  ) {
    //console.log('data', this.data);
    this.editForm = this.formBuilder.group({
      url: ['', Validators.required],
      title: [''],
      description: ['']
    });

    if ( this.data.mode === 'edit' ) {
      const photo = this.data.photos[this.data.index];
      this.editForm.setValue({
        url: photo.url,
        title: photo.title || '',
        description: photo.description || ''
      });
      this.loadingPhoto = true;
    }
  }

  preventSubmit(event: KeyboardEvent): void {
    if (event instanceof KeyboardEvent && event.key === 'Enter') {
      event.preventDefault(); // Impedisce il comportamento di default
    }
  }

  onFileSelected(event: Event): void {
    const target = event.target as HTMLInputElement;
    if (target.files && target.files.length > 0) {
      this.file = target.files[0];
      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.imageSrc = e.target.result; // Imposta l'immagine selezionata come nuova sorgente
        this.loadingPhoto = true;
      };
      reader.readAsDataURL(this.file); // Legge il file come Data URL
    }
  }

  onImageLoad(): void {
    this.loadingPhoto = false;
  }

  public async saveRecord() {
    if ( this.data.mode === 'edit') {
      const updatedPhoto: StoredPhoto = this.editForm.value;
      this.data.photos[this.data.index] = updatedPhoto;
    } 
    else { // mode === 'add'
      if (this.file) {
        try {
          this.uploading = true;
          const url = await this.storage.uploadImageAndGetUrl('photos',this.file);
          this.editForm.value.url = url;
          const newPhoto: StoredPhoto = this.editForm.value;
          this.data.photos.splice(this.data.index, 0, newPhoto);
        } catch (error) {
          console.error('Errore durante il caricamento:', error);
        } finally {
          this.uploading = false;
        }
      }
    }
    await this.db.setPhotos(this.data.photos)
      .then( () => {
        this.dialogRef.close(this.data.photos);
      })
  }

  cancel(): void {
    this.dialogRef.close(null);
  }

}
